export const formatDT = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  return d.toLocaleString(undefined, { month: "short", day: "numeric", hour: "2-digit", minute: "2-digit", hour12: false });
};

export const formatDate = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  return d.toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" });
};

export const formatTime = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  return d.toLocaleTimeString(undefined, { hour: "2-digit", minute: "2-digit", hour12: false });
};

export const toLocalInput = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

export const fromLocalInput = (s) => {
  if (!s) return null;
  return new Date(s).toISOString();
};

export const CURRENCY_SYMBOLS = {
  EUR: "€", USD: "$", GBP: "£", CAD: "CA$", AUD: "A$",
  CHF: "CHF", SEK: "kr", NOK: "kr", DKK: "kr", NZD: "NZ$",
};

export const currencySymbol = (code) => CURRENCY_SYMBOLS[(code || "EUR").toUpperCase()] || code || "€";

export const money = (n, code = "EUR") => `${currencySymbol(code)}${Number(n || 0).toFixed(2)}`;

/**
 * v77.5 — Format the time remaining until a trial ends, dynamically
 * derived from the stored `trial_end_at` ISO timestamp and the current
 * wall clock. The same helper backs the Upgrade page, the Settings
 * subscription card and the Dashboard trial notice so they always agree.
 *
 * Output rules:
 *   • >= 24h   → "N days left" (rounded up so the last partial day still
 *                 reads as "1 day left", matching legal/contract expectations)
 *   • < 24h    → "N hours left" (rounded down — "0 hours" never shown)
 *   • < 1h     → "N minutes left"
 *   • < 1m     → "Less than a minute"
 *   • <= 0     → "Trial ended"
 *   • null/inv → null (caller decides fallback copy)
 */
export const formatTrialRemaining = (trialEndIso) => {
  if (!trialEndIso) return null;
  const end = new Date(trialEndIso);
  if (Number.isNaN(end.getTime())) return null;
  const diffMs = end.getTime() - Date.now();
  if (diffMs <= 0) return "Trial ended";
  const minutes = Math.floor(diffMs / 60000);
  if (minutes < 1) return "Less than a minute left";
  if (minutes < 60) return `${minutes} minute${minutes === 1 ? "" : "s"} left`;
  const hours = Math.floor(diffMs / 3600000);
  if (hours < 24) return `${hours} hour${hours === 1 ? "" : "s"} left`;
  // Round UP so 6.2 days ≈ 7 days left (matches the backend's
  // ceiling-based count and the user's perception of "I have a week").
  const days = Math.ceil(diffMs / 86400000);
  return `${days} day${days === 1 ? "" : "s"} left`;
};
